import { Box, Dialog, Typography } from '@mui/material'
import { ROLE, useRefuseSharingMutation } from 'api'
import { selectAuth } from 'modules/auth/slice'
import { Button } from 'modules/common/components'
import { useShowError } from 'modules/errorHandler/useShowError'
import { useText } from 'modules/locale'
import { selectMe } from 'modules/me/slice'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'

type Props = { open: boolean, id: string, name: string, onClose: () => void }

export const ClassifierRefuseSharingDialog: FC<Props> = ({ onClose, id, name, open }) => {
  const { text } = useText('CLASSIFIERS')
  const { my } = useSelector(selectMe)
  const { consoleFor } = useSelector(selectAuth)
  const [refuse, { isLoading, error }] = useRefuseSharingMutation()

  const handleRefuse = async () => {
    if (my) {
      const params: { id: string, company?: string } = { id }
      consoleFor === ROLE.ORG_ADMIN && (params.company = my.organizationId)
      await refuse(params).unwrap()
      onClose()
    }
  }

  useShowError(error)

  return (
    <>
      <Dialog open={open}>
        <Typography mb='20px' variant='h2'>{text.refuseClassifier}</Typography>

        <Typography color='secondary' mb='10px' variant='body1'>{text.assignRefuse}</Typography>
        <Typography variant='body2' fontWeight={500}>{name}</Typography>

        <Box mt='40px' columnGap='20px' display='grid' gridTemplateColumns='1fr 1fr'>
          <Button loading={isLoading} variant='contained' onClick={handleRefuse}>
            {text.refuse}
          </Button>
          <Button disabled={isLoading} variant='outlined' onClick={onClose}>
            {text.cancel}
          </Button>
        </Box>
      </Dialog>
    </>
  )
}
